var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9ZM11.5 9C11.5 10.3807 10.3807 11.5 9 11.5C7.61929 11.5 6.5 10.3807 6.5 9C6.5 7.61929 7.61929 6.5 9 6.5C10.3807 6.5 11.5 7.61929 11.5 9Z",
    fill: "#1B9075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52835 19.3518C3.34219 17.2505 0.449096 13.4645 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C17.5544 13.4294 14.3295 17.1909 10.4481 19.3019C9.54146 19.7951 8.45077 19.8149 7.52835 19.3518ZM9.73143 17.9842C9.25447 18.2437 8.68285 18.253 8.2013 18.0113C4.43094 16.1186 1.91589 12.7761 1.50036 8.92558C1.54029 4.81772 4.8827 1.5 9 1.5C13.1172 1.5 16.4595 4.8175 16.4996 8.92516C16.0887 12.6886 13.2957 16.0456 9.73143 17.9842Z",
    fill: "#1B9075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8f246fc5325ee2ec9d988fad60740273.svg";
export { ForwardRef as ReactComponent };